function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-149e038b\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?sourceMap!./quickProductEdit.styl")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./quickProductEdit.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-149e038b\",\"hasScoped\":true}!./quickProductEdit.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-149e038b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/quickProductEdit/quickProductEdit.vue
// module id = 278
// module chunks = 1